import TeachingFrameworkApi from './TeachingFrameworkApi';
export default TeachingFrameworkApi;
